export default __webpack_public_path__ + "static/media/regulation.60d2d197.jpg";